import HomeComponent from '@components/home';
import * as React from 'react';

export interface IHomepageProps {}

export default function Homepage(props: IHomepageProps) {
  return <HomeComponent />;
}
